// @owners { team: patients }
import { getBrand } from '@alto/design-system';
import { ALTO_PHONE, FUZERX_PHONE, FUZE_HEALTH_PHONE } from '~shared/constants';

/**
 * Get the company phone number based on the current brand.
 * @returns string
 */
export const getCompanyPhone = () => {
  const brand = getBrand();

  if (brand === 'fuzerx') {
    return FUZERX_PHONE;
  }

  if (brand === 'fuzehealth') {
    return FUZE_HEALTH_PHONE;
  }

  if (brand === 'alto') {
    return ALTO_PHONE;
  }

  throw new Error('Unknown brand');
};
